import { apiClient } from '../../shared/api/apiClient';
import {
    parseTaskListResponse, parseTaskResponse, TaskWriteSchema,
    WorkframeListResponseSchema, WorkframeResponseSchema, TaskListSchema,
} from './schemas';

// ComponentTaskHoy.jsx
// (4836 líneas, 17 fetch()) migrado. 4 de sus endpoints eran del dominio de calendario, no de
// tareas — se reusan directo desde `features/calendar/api.js` (`fetchEvents`, `fetchEventById`,
// `createEvent`, `updateEvent`) en vez de duplicarlos acá.
//
// slice 02.1 · paso a′ — `fetchTask`/`fetchTasks` validan la respuesta con Zod (`schemas.js`);
// `createTask`/`updateTask` validan el payload de salida. Una forma equivocada *lanza* en vez
// de renderizar basura.
export const tasksApi = {
    fetchUserSpaces: (userDbId) => apiClient.get(`/api/user/${userDbId}/spaces`),
    // Fase 5.17 -- nombre del espacio de una tarea (era un `apiClient.get` inline en
    // `ComponentTaskHoy.jsx` que llenaba un `spaceNameCache` local).
    fetchSpaceName: async (spaceId) => {
        const res = await apiClient.get(`/api/space/${spaceId}`);
        return res.success && res.space ? (res.space.space_name || res.space.name || 'ESPACIO') : null;
    },
    createSpace: (name, userId) => apiClient.post('/api/space', { name, userId }),
    fetchHitos: (spaceId) => apiClient.get(`/api/tasks/hitos${spaceId ? `?space_id=${spaceId}` : ''}`),
    createHito: (payload) => apiClient.post('/api/tasks', payload),

    fetchTask: async (id) => parseTaskResponse(await apiClient.get(`/api/tasks/${id}`)),
    fetchTasks: async (params) => parseTaskListResponse(await apiClient.get(`/api/tasks${params ? `?${params}` : ''}`)),
    createTask: (payload) => apiClient.post('/api/tasks', TaskWriteSchema.parse(payload)),
    updateTask: (id, patch) => apiClient.put(`/api/tasks/${id}`, TaskWriteSchema.parse(patch)),
    updatePublicTask: (id, patch) => apiClient.put(`/api/public/tasks/${id}`, patch),
    deleteTask: (id) => apiClient.del(`/api/tasks/${id}`),

    fetchColumnWidths: (userId) => apiClient.get(`/api/customs/${userId}/task_table_column_widths`),
    saveColumnWidths: (userId, value) => apiClient.post('/api/customs', { userId, key: 'task_table_column_widths', value }),

    // ── Cuadros de trabajo / workframe (integración main→dev, epic D1) ──
    fetchWorkframes: (spaceId) =>
        apiClient.get(`/api/task-workframes${spaceId && spaceId !== 'all' ? `?space_id=${spaceId}` : ''}`)
            .then((d) => WorkframeListResponseSchema.parse(d)),
    fetchWorkframeById: (id) =>
        apiClient.get(`/api/task-workframes/${id}`).then((d) => WorkframeResponseSchema.parse(d)),
    createWorkframe: (payload) =>
        apiClient.post('/api/task-workframes', payload).then((d) => WorkframeResponseSchema.parse(d)),
    updateWorkframe: (id, payload) =>
        apiClient.put(`/api/task-workframes/${id}`, payload).then((d) => WorkframeResponseSchema.parse(d)),
    fetchWorkframeTasks: (workframeId, docId) =>
        apiClient.get(`/api/task-workframes/${workframeId}/tasks${docId ? `?doc_id=${docId}` : ''}`)
            .then((d) => ({ ...d, tasks: d.success && Array.isArray(d.tasks) ? TaskListSchema.parse(d.tasks) : [] })),

    // Prefs del panel de cuadro de trabajo (ancho del índice, columna de doc contraída) —
    // React Query sobre `/api/customs`, mismo patrón que `fetchColumnWidths` (NO `localStore`,
    // que su propio docstring excluye para estado espejado en el servidor).
    fetchWorkframePref: (userId, key) => apiClient.get(`/api/customs/${userId}/${key}`),
    saveWorkframePref: (userId, key, value) => apiClient.post('/api/customs', { userId, key, value }),
};
